import Pusher from 'pusher-js';

const rawPusherKey = import.meta.env.VITE_PUSHER_KEY;
const rawPusherCluster = import.meta.env.VITE_PUSHER_CLUSTER;

export const pusherKey = typeof rawPusherKey === 'string' ? rawPusherKey.trim() : '';
export const pusherCluster = typeof rawPusherCluster === 'string' ? rawPusherCluster.trim() : '';

export const isPusherConfigured = pusherKey.length > 0 && pusherCluster.length > 0;

export class PusherConfigurationError extends Error {
  constructor() {
    super('Pusher is not configured for this environment.');
    this.name = 'PusherConfigurationError';
  }
}

type PusherOptions = ConstructorParameters<typeof Pusher>[1];
type CreatePusherOptions = Omit<PusherOptions, 'cluster'> & { cluster?: string };

export function createPusher(options: CreatePusherOptions): Pusher {
  if (!isPusherConfigured) {
    throw new PusherConfigurationError();
  }

  return new Pusher(pusherKey, {
    ...options,
    cluster: pusherCluster,
  });
}
